import { IToolManagementListVM } from '../../models/response/IToolManagementResponse';
const initialToolManagementState: IToolManagementListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  Tools: [],
};

export default initialToolManagementState;
